import styled from 'styled-components';

export const Option = styled.div`
	text-align: center;
	&:hover {
		cursor: pointer;
	}
`;
